export const TOKEN = 'Token';
//# sourceMappingURL=TOKEN.js.map